import { useState } from 'react'
import { Sparkles, Copy, Download } from 'lucide-react'
import { api } from '../services/api'

export default function FunnelGenerator() {
  const [type, setType] = useState('lead_magnet')
  const [topic, setTopic] = useState('')
  const [result, setResult] = useState('')
  const [loading, setLoading] = useState(false)

  const copyTypes = [
    { value: 'lead_magnet', label: '🎁 리드 마그넷' },
    { value: 'subject_lines', label: '📧 이메일 제목' },
    { value: 'landing_page', label: '🎯 랜딩페이지' },
    { value: 'chatbot_script', label: '💬 챗봇 스크립트' },
    { value: 'email_sequence', label: '📬 이메일 시퀀스' },
    { value: 'upsell_pitch', label: '💰 업셀 피치' },
    { value: 'social_captions', label: '📱 소셜 캡션' },
  ]

  const handleGenerate = async () => {
    if (!topic.trim()) return

    try {
      setLoading(true)
      const data = await api.generateFunnelCopy(type, topic)
      setResult(data.content)
    } catch (error) {
      console.error('Failed to generate:', error)
      alert('생성 실패. API 키를 확인하세요.')
    } finally {
      setLoading(false)
    }
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(result)
    alert('클립보드에 복사되었습니다!')
  }

  const handleDownload = () => {
    const blob = new Blob([result], { type: 'text/plain' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `funnel_copy_${type}_${Date.now()}.txt`
    a.click()
  }

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <h1 className="text-3xl font-bold text-white">🎨 AI 퍼널 카피 생성기</h1>

      <div className="bg-slate-800 rounded-lg p-6 space-y-4">
        <div>
          <label className="block text-gray-400 mb-2">카피 타입</label>
          <select
            value={type}
            onChange={(e) => setType(e.target.value)}
            className="w-full bg-slate-700 text-white px-4 py-3 rounded-lg"
          >
            {copyTypes.map((ct) => (
              <option key={ct.value} value={ct.value}>
                {ct.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-gray-400 mb-2">주제/제품명</label>
          <input
            type="text"
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
            placeholder="예: 사주 운세 서비스, AI 챗봇, 크라우드펀딩 플랫폼"
            className="w-full bg-slate-700 text-white px-4 py-3 rounded-lg"
          />
        </div>

        <button
          onClick={handleGenerate}
          disabled={loading || !topic.trim()}
          className="w-full flex items-center justify-center px-6 py-3 bg-sky-600 text-white rounded-lg hover:bg-sky-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <Sparkles className={`h-5 w-5 mr-2 ${loading ? 'animate-spin' : ''}`} />
          {loading ? '생성 중...' : 'AI 카피 생성 (5분)'}
        </button>
      </div>

      {result && (
        <div className="bg-slate-800 rounded-lg p-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-bold text-white">✨ 생성된 카피</h2>
            <div className="flex space-x-2">
              <button
                onClick={handleCopy}
                className="flex items-center px-3 py-2 bg-slate-700 text-white rounded-lg hover:bg-slate-600"
              >
                <Copy className="h-4 w-4 mr-2" />
                복사
              </button>
              <button
                onClick={handleDownload}
                className="flex items-center px-3 py-2 bg-slate-700 text-white rounded-lg hover:bg-slate-600"
              >
                <Download className="h-4 w-4 mr-2" />
                다운로드
              </button>
            </div>
          </div>

          <div className="bg-slate-900 rounded-lg p-4">
            <pre className="text-gray-300 whitespace-pre-wrap font-mono text-sm">
              {result}
            </pre>
          </div>
        </div>
      )}

      <div className="bg-slate-800 rounded-lg p-6">
        <h3 className="text-lg font-bold text-white mb-3">💡 사용 팁</h3>
        <ul className="space-y-2 text-gray-400">
          <li>• 구체적인 주제를 입력할수록 더 나은 결과를 얻을 수 있습니다</li>
          <li>• 생성된 카피는 자유롭게 수정하여 사용하세요</li>
          <li>• 여러 번 생성하여 최적의 버전을 선택하세요</li>
          <li>• A/B 테스트를 통해 성과를 비교해보세요</li>
        </ul>
      </div>
    </div>
  )
}
